<script setup lang="ts">
import { ref } from "vue";
import InputLabel from "@/components/ui/InputLabel.vue";

type Props = {
  type?: string;
  modelValue?: string;
  placeholder?: string;
  label?: string;
  labelDisabled?: boolean;
  autocomplete?: string;
  errorMessage?: string;
  hasError?: boolean;
};

type Emits = {
  (e: "update:modelValue", value: string): void;
};

const props = withDefaults(defineProps<Props>(), {
  type: "text",
  modelValue: "",
  placeholder: "",
  label: "Label",
  labelDisabled: false,
  hasError: false,
});

const emit = defineEmits<Emits>();

const hasBeenFocused = ref(false);
const hasBeenBlurred = ref(false);

function onInput(event: Event): void {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
}
</script>

<template>
  <div>
    <input-label :text="label" :disabled="labelDisabled" />
    <input
      :id="label.toLowerCase()"
      :value="modelValue"
      :autocomplete="autocomplete"
      class="w-full appearance-none rounded border-2 border-kekkle-dark-dark px-3 py-2 text-kekkle-dark shadow-blue-hard-sm outline-none focus:ring focus:ring-kekkle-blue dark:bg-kekkle-dark-light dark:text-slate-200"
      :type="type"
      :placeholder="placeholder"
      @input="onInput"
      @focus="hasBeenFocused = true"
      @blur="hasBeenBlurred = true"
    />
    <p
      v-show="hasError && hasBeenFocused"
      class="mt-1 text-sm text-red-600 dark:text-red-400"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>
